import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const SingleItem = ({ data, handleClose }) => {
  const [livePrice, setLivePrice] = useState([]);
  const [loading, setLoading] = useState(true);
  const { crypto_currency_id: cryptoCurrencyData } = data;

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 1000);
    return () => clearInterval(interval);
  }, [livePrice]);

  const fetchData = async () => {
    if (cryptoCurrencyData !== null) {
      fetch(
        `https://api.massive.com/v2/snapshot/locale/global/markets/crypto/tickers/X:${cryptoCurrencyData?.Symbol}${cryptoCurrencyData?.currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.ticker) {
            setLivePrice(data?.ticker);
          }
          if (loading) {
            setLoading(false);
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    }
  };

  if (loading || cryptoCurrencyData === null) {
    return;
  }

  return (
    <>
      <li>
        <NavLink
          onClick={handleClose}
          className="menu-item "
          to={`/user/trade/crypto/${cryptoCurrencyData?._id}`}
          end={true}
        >
          <div className="d-flex justify-content-between gap-1">
            <div className="text-xl">
              <span>{cryptoCurrencyData?.Name}</span>
              <span className="opacity-50 text-base font-light">
                <br /> {cryptoCurrencyData?.Symbol}
              </span>
            </div>
            <div className="d-flex justify-content-between mt-1">
              <div className="text-gray-400 font-light text-sm  trade-sidebar-price">
                {!isNaN(livePrice?.lastTrade?.p) && parseFloat(livePrice?.lastTrade?.p) + parseFloat(cryptoCurrencyData?.price)}$
              </div>
            </div>
          </div>
        </NavLink>
      </li>
    </>
  );
};

export default SingleItem;
